import { IProviderDetails, TipsConfig } from "@/types/organization-providers"
import { OrderStatusesTypes } from "@/types/statuses.types"
import { ProvidersType } from "@/types/providers.types"
import { CountryCode } from "libphonenumber-js"

const defaultTips = {
  options: [],
  maxTip: undefined
}

export const isTippable = (
  status: OrderStatusesTypes,
  orgCountry: CountryCode,
  providerDetails?: IProviderDetails
): boolean => {
  const providerHasTips = providerDetails?.name === ProvidersType.OWN_FLEET || !!providerDetails?.tips?.active
  const isStatusTippable = [OrderStatusesTypes.CREATED, OrderStatusesTypes.SUBMITTED].includes(status) ||
    (providerDetails?.name === ProvidersType.OWN_FLEET && ![OrderStatusesTypes.CANCELLED, OrderStatusesTypes.FAILED, OrderStatusesTypes.RETURNED].includes(status))
  const isCountryEnabled = providerDetails?.name === ProvidersType.OWN_FLEET || getCountryTipsConfig(orgCountry, providerDetails)

  return providerHasTips && isStatusTippable && !!isCountryEnabled
}

export const getCountryTipsConfig = (
  orgCountry: CountryCode,
  providerDetails?: IProviderDetails
): TipsConfig | { options: never[], maxTip: undefined } => {
  return providerDetails?.tips?.[orgCountry] || defaultTips
}

export const getCountryFeeStart = (
  orgCountry: CountryCode,
  providerDetails?: IProviderDetails
): number | null | undefined => {
  return providerDetails?.feeStart?.[orgCountry]
}
